export default __webpack_public_path__ + "static/media/_logo_only_gray.d587edea.png";